import React from 'react';
import { NavLink } from 'react-router-dom';
import { Collapse, Stack, Tooltip } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import './styles.css';

// Piezas del menú lateral. Los colores no están aquí: salen de las variables --nav-* que
// define MuiDrawer en theme/theme.js (ver links/styles.css).
//
// Con el menú cerrado solo se ve el ícono, así que el nombre sale en un Tooltip.
// NavLink recibe un className de texto (no una función) para que el Tooltip pueda
// agregarle sus propias clases; NavLink le pone "active" y aria-current al enlace activo.

const Icono = ({ children }) => (
	<span className="item-nav-icono" aria-hidden="true">
		{children}
	</span>
);

/**
 * Enlace del menú. Con `to` navega dentro de la SPA; con `href` abre una dirección externa
 * (la sirve el servidor, fuera de la SPA) en otra pestaña.
 * `icono` es un elemento (FontAwesomeIcon con `fixedWidth`, o un ícono de MUI).
 */
export const ItemNav = ({ to, end, href, icono, texto, drawerIsOpen }) => {
	const contenido = (
		<>
			<Icono>{icono}</Icono>
			<span className="item-nav-texto">{texto}</span>
		</>
	);

	return (
		<Tooltip title={drawerIsOpen ? '' : texto} placement="right">
			{href ? (
				<a href={href} target="_blank" rel="noopener noreferrer" className="item-nav">
					{contenido}
				</a>
			) : (
				<NavLink to={to} end={end} className="item-nav">
					{contenido}
				</NavLink>
			)}
		</Tooltip>
	);
};

/**
 * Grupo desplegable del menú (RRHH, Seguridad, Configuraciones). Los enlaces del grupo van
 * como `children`; cerrado por defecto, igual que antes.
 */
export const GrupoNav = ({ icono, texto, drawerIsOpen, children }) => {
	const [abierto, setAbierto] = React.useState(false);

	return (
		<div>
			<Tooltip title={drawerIsOpen ? '' : texto} placement="right">
				<button
					type="button"
					className="item-nav item-nav-grupo"
					aria-expanded={abierto}
					onClick={() => setAbierto(!abierto)}
				>
					<Icono>{icono}</Icono>
					<span className="item-nav-texto">{texto}</span>
					<span className="item-nav-flecha" aria-hidden="true">
						{abierto ? <ExpandLess /> : <ExpandMore />}
					</span>
				</button>
			</Tooltip>

			<Collapse in={abierto} timeout="auto" unmountOnExit>
				<Stack spacing={0.25} sx={{ mt: 0.25, pl: drawerIsOpen ? 2 : 0 }}>
					{children}
				</Stack>
			</Collapse>
		</div>
	);
};
